import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import Layout from '../components/layout' //Layout 是架构组件，不在后台返回，在文件里单独引入
var constantRouterMap = [{
    path: "/",
    component: Layout,
    name: "homepage",
    redirect: "/homepage",
    meta: {
      title: "首页",
      icon: "home",
      keepAlive: true
    },
    children: [{
      path: "/homepage",
      name: "homePage",
      component: () => import("@/views/homePage/index"),
      meta: {
        title: "首页",
        icon: "home",
        keepAlive: true
      }
    },{
      path: "/about",
      name: "about",
      component: () => import("@/views/about/index"),
      meta: {
        title: "关于我们",
        icon: "about",
        keepAlive: true
      }
    },{
      path: "/Amazon",
      name: "Amazon",
      component: () => import("@/views/Amazon/index"),
      meta: {
        title: "亚马逊服务政策",
        icon: "about",
        keepAlive: true
      }
    }]
  },
  {
    path: "/403",
    name: "403",
    meta: {
      title: "403",
      icon: "eabyPublish",
      keepAlive: true
    },
    hidden: true
  }
]
export default new Router({
  mode: "hash",
  // mode: "history",
  base: process.env.publicPath,
  routes: constantRouterMap,
});